// src/api/client.js
// import axios from "axios";

// const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

// export const api = axios.create({
//   baseURL: BASE,
// });

// // attach JWT + language automatically
// api.interceptors.request.use((config) => {
//   const token = localStorage.getItem("token");
//   const lang = localStorage.getItem("lang") || "en";
//   if (!config.headers) config.headers = {};
//   config.headers["Accept-Language"] = lang;
//   if (token) config.headers.Authorization = `Bearer ${token}`;
//   return config;
// });

// // Optional: handle demo read-only + auth issues globally
// api.interceptors.response.use(
//   (res) => res,
//   (err) => {
//     const { status, data } = err.response || {};
//     if (status === 401) {
//       localStorage.removeItem("token");
//       localStorage.removeItem("isDemo");
//       if (typeof window !== "undefined") window.location.href = "/login";
//     } else if (status === 403 && data?.error === "DEMO_READ_ONLY") {
//       alert("Demo mode: create/update/delete actions are disabled.");
//     }
//     return Promise.reject(err);
//   }
// );

// src/api/client.js// src/api/client.js
import axios from "axios";
import { message } from "antd";

const BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export const api = axios.create({
  baseURL: BASE,
  timeout: 30000,
});

const isArabicLang = () =>
  (localStorage.getItem("lang") || "en").toLowerCase().startsWith("ar");

const showPermissionDeniedToast = () => {
  const text = isArabicLang()
    ? "ليس لديك صلاحية للوصول إلى هذه الصفحة. يرجى التواصل مع المدير."
    : "You don't have permission to access this page. Please contact your admin.";
  try {
    message.error({ content: text, key: "permission-denied", duration: 4 });
  } catch (_) {
    // no-op (message system may not be mounted yet)
  }
};

const isPermissionDeniedResponse = (err, status, serverMessage) => {
  if (!(status === 401 || status === 403)) return false;

  const fullUrl = `${err?.config?.baseURL || ""}${err?.config?.url || ""}`.toLowerCase();
  const msg = String(serverMessage || "").toLowerCase();
  const code = String(err?.response?.data?.code || err?.response?.data?.error || "").toLowerCase();
  const isPosSubscription = /\/api\/pos-subscription\b/.test(fullUrl);
  const isDemoReadOnly = code === "demo_read_only";
  const isNoStoreError =
    /no\s*storeid\s*on\s*user/.test(msg) || /no\s*store\s*on\s*user/.test(msg);
  const hasPermissionHint =
    /permission|forbidden|access\s*denied|not\s*allowed|insufficient|unauthorized/.test(
      msg
    ) ||
    /permission|forbidden/.test(code) ||
    /صلاحية|غير\s*مسموح/.test(msg);

  if (isDemoReadOnly || isNoStoreError) return false;

  // Treat permission-denied as non-auth logout errors
  if (status === 403) return isPosSubscription || hasPermissionHint;
  // Some backends send 401 for permission checks
  return isPosSubscription || hasPermissionHint;
};

// ---- Demo helpers (unchanged) ----
export const isDemoActive = () => localStorage.getItem("isDemo") === "1";
export const setDemoActive = (active, reason) => {
  if (active) {
    localStorage.setItem("isDemo", "1");
    if (reason) localStorage.setItem("demoReason", reason);
  } else {
    localStorage.removeItem("isDemo");
    localStorage.removeItem("demoReason");
  }
};
export const getDemoReason = () => localStorage.getItem("demoReason") || "";

// Use this only if your UI lets the user switch stores for /internal routes
export const setTenantHeader = (storeId) => {
  const sid = storeId ? String(storeId) : null;
  if (sid) localStorage.setItem("storeId", sid);
  else localStorage.removeItem("storeId");
};

// -------------- REQUEST INTERCEPTOR (single) --------------
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");           // read fresh on every request
  const lang  = localStorage.getItem("lang") || "en";
  const storeId = localStorage.getItem("storeId");       // optional, only for /internal

  config.headers = config.headers || {};
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const hasAcceptLanguageHeader = Boolean(
    config.headers["Accept-Language"] || config.headers["accept-language"]
  );
  if (!hasAcceptLanguageHeader) {
    config.headers["Accept-Language"] = lang;
  }
  config.headers["Cache-Control"]   = "no-store";

  // Attach X-Store-Id **only** for /internal calls; never leak it to /api
  const fullUrl = `${config.baseURL || ""}${config.url || ""}`;
  if (/\/internal\b/.test(fullUrl)) {
    if (storeId) config.headers["X-Store-Id"] = storeId;
  } else {
    delete config.headers["X-Store-Id"];
  }

  return config;
});

// -------------- RESPONSE INTERCEPTOR (single) --------------
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const { status, data } = err.response || {};
    const serverMessage = data?.message || "";

    if (isPermissionDeniedResponse(err, status, serverMessage)) {
      showPermissionDeniedToast();
      err.__permissionToastShown = true;
      return Promise.reject(err);
    }

    if (status === 401) {
      // clear auth + caches on sign-out
      localStorage.removeItem("token");
      localStorage.removeItem("authToken");
      localStorage.removeItem("userPermissions");
      localStorage.removeItem("userRole");
      setDemoActive(false);
      if ("caches" in window) {
        caches.keys().then((keys) => keys.forEach((k) => caches.delete(k)));
      }
      window.location.replace("/signin");
    } else if (status === 403) {
      if (data?.error === "DEMO_READ_ONLY") {
        alert("Demo mode: create/update/delete actions are disabled.");
      }
      const noStore =
        /no\s*storeid\s*on\s*user/i.test(serverMessage) ||
        /no\s*store\s*on\s*user/i.test(serverMessage);
      if (noStore) setDemoActive(true, serverMessage);
    }
    return Promise.reject(err);
  }
);
